import * as $ from "jquery";
import Vue from "vue";
import Component from "vue-class-component";
import { AbsenceClotureCreationContratDto } from "../../../dto/GenApi.iNotPaie.Dto/AbsenceClotureCreationContratDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

@Component
export default class ModalAbsencesFuturesFinDeContrat extends Vue {
	public continueProcess?: Function = undefined;
    public listeAbsences: AbsenceClotureCreationContratDto[] = [];

    public init(absences: AbsenceClotureCreationContratDto[]): void {
        this.listeAbsences = absences;
        $("#modalAbsencesFuturesFinDeContrat").modal("show");
    }

    public valider(): void {
        if (this.listeAbsences[0].IdContrat == undefined)
            return;

        ServicesFactoryInstance.AbsencesService.annulerAbsencesFuturesFinDeContrat(this.listeAbsences[0].IdContrat, () => {
            NotificationServiceInstance.SendSuccess("Les absences futures ont bien été annulées.");
            this.$emit("refreshAbsences");
            
            this.close();
        }, () => {
            NotificationServiceInstance.SendFailed("Une erreur s'est produite lors de l'annulation des absences.");

            this.close();
        });
    }

    public cancel(): void {

        this.close();
    }

    private close() {
        if (this.continueProcess != undefined) {
            this.continueProcess();
        }
        $("#modalAbsencesFuturesFinDeContrat").modal("hide");
    }
}



// WEBPACK FOOTER //
// ./src/components/modalComponents/modalAbsencesFuturesFinDeContrat/modalAbsencesFuturesFinDeContrat.ts